var tinycolor = require("tinycolor2");
const drawerWidth = 260;

const transition = {
  transition: "all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
};

const conatinerFluid = {
  paddingRight: "15px",
  paddingLeft: "15px",
  marginRight: "auto",
  marginLeft: "auto",
  width: "100%"
};
const container = {
  ...conatinerFluid,
  "@media (min-width: 576px)": {
    maxWidth: "540px"
  },
  "@media (min-width: 768px)": {
    maxWidth: "720px"
  },
  "@media (min-width: 992px)": {
    maxWidth: "960px"
  },
  "@media (min-width: 1200px)": {
    maxWidth: "1140px"
  }
};

const boxShadow = {
  boxShadow:
    "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
};

const card = {
  display: "inline-block",
  position: "relative",
  width: "100%",
  margin: "25px 0",
  boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
  borderRadius: "3px",
  color: "rgba(0, 0, 0, 0.87)",
  background: "#fff"
};

const defaultFont = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: "300",
  lineHeight: "1.5em"
};

const primaryColor = "#191B1B";
const secondaryColor = "#3C4858";
const warningColor = "#ffa726";
const dangerColor = "#ef5350";
const successColor = "#66bb6a";
const infoColor = "#26c6da";
const roseColor = "#e91e63";
const grayColor = "#999999";
const darkColor = tinycolor(primaryColor).darken(8).toHexString();
const lightGrayColor = "rgba(214, 214, 214, 0.5)";

const primaryBoxShadow = {
  boxShadow:
    `0 12px 20px -10px ${tinycolor(primaryColor).setAlpha(.28).toRgbString()}, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px ${tinycolor(primaryColor).setAlpha(.2).toRgbString()}`
};
const infoBoxShadow = {
  boxShadow:
    `0 12px 20px -10px ${tinycolor(infoColor).setAlpha(.28).toRgbString()}, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px ${tinycolor(infoColor).setAlpha(.2).toRgbString()}`
};
const successBoxShadow = {
  boxShadow:
    `0 12px 20px -10px ${tinycolor(successColor).setAlpha(.28).toRgbString()}, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px ${tinycolor(successColor).setAlpha(.2).toRgbString()}`
};
const warningBoxShadow = {
  boxShadow:
    `0 12px 20px -10px ${tinycolor(warningColor).setAlpha(.28).toRgbString()}, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px ${tinycolor(warningColor).setAlpha(.2).toRgbString()}`
};
const dangerBoxShadow = {
  boxShadow:
    `0 12px 20px -10px ${tinycolor(dangerColor).setAlpha(.28).toRgbString()}, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px ${tinycolor(dangerColor).setAlpha(.2).toRgbString()}`
};
const roseBoxShadow = {
  boxShadow:
    `0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px ${tinycolor(roseColor).setAlpha(.28).toRgbString()}`
};

const warningCardHeader = {
  color: "#fff",
  background: `linear-gradient(60deg, ${warningColor}, ${tinycolor(warningColor).darken(8).toHexString()})`,
  ...warningBoxShadow
};
const successCardHeader = {
  color: "#fff",
  background: `linear-gradient(60deg, ${successColor}, ${tinycolor(successColor).darken(8).toHexString()}`,
  ...successBoxShadow
};
const dangerCardHeader = {
  color: "#fff",
  background: `linear-gradient(60deg, ${dangerColor}, ${tinycolor(dangerColor).darken(8).toHexString()}`,
  ...dangerBoxShadow
};
const infoCardHeader = {
  color: "#fff",
  background: `linear-gradient(60deg, ${infoColor}, ${tinycolor(infoColor).darken(8).toHexString()}`,
  ...infoBoxShadow
};
const primaryCardHeader = {
  color: "#fff",
  background: `linear-gradient(60deg, ${primaryColor}, ${tinycolor(primaryColor).darken(8).toHexString()}`,
  ...primaryBoxShadow
};
const secondaryCardHeader = {
  color: "#fff",
  background: `linear-gradient(60deg, ${secondaryColor}, ${tinycolor(secondaryColor).darken(8).toHexString()}`,
  ...primaryBoxShadow
};
const roseCardHeader = {
  color: "#fff",
  background: `linear-gradient(60deg, ${roseColor}, ${tinycolor(roseColor).darken(8).toHexString()}`,
  ...roseBoxShadow
};
const cardActions = {
  margin: "0 20px 10px",
  paddingTop: "10px",
  borderTop: "1px solid #eeeeee",
  height: "auto",
  ...defaultFont
};

const cardHeader = {
  margin: "-30px 15px 0",
  borderRadius: "3px",
  padding: "15px"
};

const defaultBoxShadow = {
  border: "0",
  borderRadius: "3px",
  boxShadow:
    "0 10px 20px -12px rgba(0, 0, 0, 0.42), 0 3px 20px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
  padding: "10px 0",
  transition: "all 150ms ease 0s"
};

const title = {
  color: secondaryColor,//tinycolor(secondaryColor).darken(20).toHexString(),
  margin: "1.75rem 0 0.875rem",
  textDecoration: "none",
  fontWeight: "700",
  fontFamily: `"Roboto Slab", "Times New Roman", serif`
};

const cardTitle = {
  ...title,
  marginTop: ".625rem"
};

const cardLink = {
  "& + $cardLink": {
    marginLeft: "1.25rem"
  }
};

const cardSubtitle = {
  marginBottom: "0",
  marginTop: "-.375rem"
};

export {
  //variables
  drawerWidth,
  transition,
  container,
  conatinerFluid,
  boxShadow,
  card,
  defaultFont,
  primaryColor,
  secondaryColor,
  warningColor,
  dangerColor,
  successColor,
  darkColor,
  infoColor,
  roseColor,
  grayColor,
  lightGrayColor,
  primaryBoxShadow,
  infoBoxShadow,
  successBoxShadow,
  warningBoxShadow,
  dangerBoxShadow,
  roseBoxShadow,
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  secondaryCardHeader,
  roseCardHeader,
  cardActions,
  cardHeader,
  defaultBoxShadow,
  title,
  cardTitle,
  cardLink,
  cardSubtitle
};
